import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/emptyStatus.svg'


const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('page-content-empty d-flex flex-column justify-content-center align-items-center p-5')
}
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 1,
  class: "page-content shadow-sm"
}
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center my-3" }
const _hoisted_7 = { class: "ps-3" }
const _hoisted_8 = { class: "p-input-icon-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "table-organizations" }
const _hoisted_11 = { class: "d-flex justify-content-around" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_ds_header = _resolveComponent("ds-header")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createVNode(_component_ds_header, {
      hasButton: true,
      title: _ctx.$t('org.title'),
      buttonText: _ctx.$t('org.register'),
      buttonRoute: "AddOrganization"
    }, null, 8, ["title", "buttonText"]),
    (_ctx.organizationTotal < 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _ctx.$t('org.noOrgsAlt'),
            class: "mb-4 mt-5"
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('org.noOrgs')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_InputText, {
                  modelValue: _ctx.params.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.name) = $event)),
                  placeholder: _ctx.$t('org.search'),
                  onKeyup: _ctx.organizationsPaginate
                }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
                _hoisted_9
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_DataTable, {
              value: _ctx.organizations,
              responsiveLayout: "scroll",
              rows: _ctx.params.size,
              showGridlines: "",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event))
            }, {
              empty: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t('org.noOrgsAlt')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "name",
                  header: _ctx.$t('org.fields.name'),
                  sortable: true,
                  removableSort: ""
                }, null, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "cnpj",
                  header: "CNPJ",
                  sortable: true,
                  removableSort: ""
                }),
                _createVNode(_component_Column, {
                  field: "status",
                  header: "Status",
                  class: "status-column"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", {
                      class: _normalizeClass('status-span status-' + (slotProps.data.status ? slotProps.data.status.toLowerCase() : ''))
                    }, _toDisplayString(_ctx.isActive(slotProps.data.status)), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: _ctx.$t('utils.edit')
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        class: "material-symbols-outlined",
                        onClick: () => _ctx.$router.push({ name: 'editOrganization', params: { id: slotProps.data.id } })
                      }, [
                        _createTextVNode(" edit ")
                      ], 8, _hoisted_12)), [
                        [
                          _directive_tooltip,
                          _ctx.$t('utils.edit'),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(["material-symbols-outlined", slotProps.data.status === 'ACTIVATED' ? 'deactivate' : 'activate']),
                        onClick: ($event: any) => (_ctx.updateStatus(slotProps.data.id))
                      }, [
                        _createTextVNode(" do_not_disturb_on ")
                      ], 10, _hoisted_13)), [
                        [
                          _directive_tooltip,
                          slotProps.data.status === 'ACTIVATED' ? _ctx.$t('utils.deactivate') : _ctx.$t('utils.activate'),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        class: "material-icons delete-icon",
                        onClick: ($event: any) => (_ctx.confirmDelete(slotProps.data.id))
                      }, [
                        _createTextVNode(" delete ")
                      ], 8, _hoisted_14)), [
                        [
                          _directive_tooltip,
                          _ctx.$t('utils.delete'),
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value", "rows", "filters"]),
            _createVNode(_component_Paginator, {
              rows: _ctx.params.size,
              totalRecords: _ctx.params.total,
              onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginate($event)))
            }, null, 8, ["rows", "totalRecords"])
          ])
        ]))
  ]))
}